import { DataLayer } from '@grandvisionhq/analytics';

const eventName = 'size guide';
const eventAction = 'click';
const pushSizeGuideLinkClickEvent = (sku, name)=>{
    DataLayer.pushEvent({
        event: eventName,
        eventAction,
        eventLabel: `open - ${sku} - ${name}`
    });
};
const pushBookAppointmentClickEvent = (sku, name)=>{
    DataLayer.pushEvent({
        event: eventName,
        eventAction,
        eventLabel: `book an appointment - ${sku} - ${name}`
    });
};

export { pushBookAppointmentClickEvent, pushSizeGuideLinkClickEvent };
//# sourceMappingURL=SizeGuideEvents.js.map
